import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../../service/core.service';

@Component({
  selector: 'app-rep-branch-transfer',
  templateUrl: './rep-branch-transfer.component.html',
  styleUrls: ['./rep-branch-transfer.component.css']
})
export class RepBranchTransferComponent implements OnInit {
  up: any;

  constructor(private coreService: CoreService) { }

  ngOnInit() {
    this.up = this.coreService.getUserPrivilage();

  }

}
